import PropTypes from 'prop-types';
import React from 'react';
import { BadgeWrapper, A11yText } from './PlayBadge.styles';

export const PLAY_BADGE_THEME = {
    LIVE: 'live',
    UPCOMING_LIVE: 'upcomingLive',
    UPCOMING: 'upcoming',
    NEXT_EPISODE: 'nextEpisode',
    OPEN_ARCHIVE: 'oppetArkiv',
    LAST_CHANCE: 'lastChance',
};

export const PLAY_BADGE_SIZE = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
    XLARGE: 'XLARGE',
};

export const PLAY_BADGE_COLORS = {
    GREY: 'GREY',
    RED: 'RED',
    YELLOW: 'YELLOW',
};

export const getColor = (theme) => {
    switch (theme) {
        case PLAY_BADGE_THEME.LIVE:
            return PLAY_BADGE_COLORS.RED;
        case PLAY_BADGE_THEME.LAST_CHANCE:
            return PLAY_BADGE_COLORS.YELLOW;
        case PLAY_BADGE_THEME.UPCOMING_LIVE:
        case PLAY_BADGE_THEME.UPCOMING:
        case PLAY_BADGE_THEME.NEXT_EPISODE:
        case PLAY_BADGE_THEME.OPEN_ARCHIVE:
            return PLAY_BADGE_COLORS.GREY;
        default:
            return PLAY_BADGE_COLORS.GREY;
    }
};

export const PlayBadge = ({
    text,
    accessibilityText,
    theme,
    size = PLAY_BADGE_SIZE.MEDIUM,
    className,
    overlay, // Position the badge in the top left corner over an image
}) => {
    const ariaHidden = accessibilityText ? true : false;
    const AccessibilityText = accessibilityText ? <A11yText>{accessibilityText}</A11yText> : false;
    const color = getColor(theme);

    return (
        <BadgeWrapper theme={theme} badgeColor={color} size={size} className={className} overlay={overlay}>
            <span aria-hidden={ariaHidden}>{text}</span>
            {AccessibilityText}
        </BadgeWrapper>
    );
};

PlayBadge.propTypes = {
    text: PropTypes.string.isRequired,
    accessibilityText: PropTypes.string,
    theme: PropTypes.oneOf([
        PLAY_BADGE_THEME.LIVE,
        PLAY_BADGE_THEME.UPCOMING_LIVE,
        PLAY_BADGE_THEME.UPCOMING,
        PLAY_BADGE_THEME.NEXT_EPISODE,
        PLAY_BADGE_THEME.OPEN_ARCHIVE,
        PLAY_BADGE_THEME.LAST_CHANCE,
    ]).isRequired,
    size: PropTypes.oneOf([
        PLAY_BADGE_SIZE.SMALL,
        PLAY_BADGE_SIZE.MEDIUM,
        PLAY_BADGE_SIZE.LARGE,
        PLAY_BADGE_SIZE.XLARGE,
    ]),
    overlay: PropTypes.bool,
    className: PropTypes.string,
};

export default PlayBadge;
